import { IconName, Icon, Heading3, P } from '@ovotech/nebula';
import React, { ComponentProps, ReactElement, ReactNode } from 'react';
import {
  StyledIconHeader,
  StyledIconHeaderText,
  StyledIconHeaderIcon,
} from './IconHeader.styled';

type Props = ComponentProps<typeof StyledIconHeader> & {
  heading: ReactNode;
  subtitle?: ReactNode;
  icon: IconName | string | ReactElement;
};

const IconHeader = ({ heading, subtitle, icon, ...rest }: Props) => (
  <StyledIconHeader {...rest}>
    {typeof icon === 'string' ? (
      <StyledIconHeaderIcon>
        <Icon name={icon} />
      </StyledIconHeaderIcon>
    ) : (
      icon
    )}
    <StyledIconHeaderText>
      {typeof heading === 'string' ? (
        <Heading3 as="h2">{heading}</Heading3>
      ) : (
        heading
      )}
      {subtitle ? <P data-testid="icon-header-subtitle">{subtitle}</P> : null}
    </StyledIconHeaderText>
  </StyledIconHeader>
);

export { IconHeader };
